let settings = { currency: 'EUR', locale: 'hu-HU' }
export function configureFormat(next) { settings = { ...settings, ...next } }

export function money(value, { currency = settings.currency, digits = 0, sign = false } = {}) {
  if (value == null || Number.isNaN(value)) return '–'
  const s = new Intl.NumberFormat(settings.locale, {
    style: 'currency', currency, maximumFractionDigits: digits, minimumFractionDigits: digits,
  }).format(value)
  return sign && value > 0 ? `+${s}` : s
}

export function compactMoney(value) {
  return new Intl.NumberFormat(settings.locale, {
    style: 'currency', currency: settings.currency, notation: 'compact', maximumFractionDigits: 1,
  }).format(value)
}

export function number(value, digits = 2) {
  return new Intl.NumberFormat(settings.locale, { maximumFractionDigits: digits }).format(value)
}

export const todayISO = () => toISO(new Date())
export function toISO(d) {
  const y = d.getFullYear(), m = String(d.getMonth() + 1).padStart(2, '0'), day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}
export const monthKey = (iso) => iso.slice(0, 7)

export function monthLabel(key, style = 'long') {
  const [y, m] = key.split('-').map(Number)
  return new Date(y, m - 1, 1).toLocaleDateString('en-GB', { month: style, year: 'numeric' })
}
export function dateLabel(iso) {
  const [y, m, d] = iso.split('-').map(Number)
  return new Date(y, m - 1, d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}
